import React, { useState } from "react";
import {
  Card,
  CardHeader,
  CardMedia,
  CardContent,
  CardActions,
  Collapse,
  IconButton,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ProjectCard = ({ project }) => {
  const [expanded, setExpanded] = useState(false);

  return (
<Card
  sx={{
    height: 240,
    display: "flex",
    flexDirection: "column",
  }}
>
    <CardMedia
    component="img"
    height="160"
    image={project.image}
    alt={project.name}
  />
  <CardHeader
    title={
      <Typography
        component="a"
        href={project.project_link}
        target="_blank"
        rel="noopener noreferrer"
        variant="h6"
        sx={{
          textDecoration: "none",
          color: "inherit",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
        }}
      >
        {project.name}
      </Typography>
    }
    subheader={project.location}
  />

 <CardContent
    sx={{
      pt: 0,
      overflow: "hidden",
    }}
  >
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 3,
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {project.description}
    </Typography>
  </CardContent>
</Card>
  );
};

export default ProjectCard;